<router-outlet></router-outlet>
<!-- loading spinner | enable with a conditional -->
<!-- <app-loading-screen></app-loading-screen> -->